<!-- eslint-disable -->
<template>
  <div :class="P_customClass">
    <component :is="DV_componentType">{{P_customCss}}</component>
    <button 
      v-show="C_isVisible"
      :style="C_buttonStyle" 
      :class="{active: C_isActiveState}"
      :disabled="isTrue(P_disabled) || P_editing"
      @mousedown="eventMouseDown(P_buttonId, P_makeSingleEvent)"
      @mouseup="eventMouseRelease(P_buttonId, P_makeSingleEvent)"
      @click="eventMouseClick(P_buttonId, P_makeSingleEvent)"
    >
      <div v-if="P_imgSrc" :style="C_imgStyle" class="img-container"><img :src="P_imgSrc"></div>
      <div :style="C_textStyle" class="text-container">{{P_buttonText}}</div>
    </button>
  </div>
</template>

<script>
/* eslint-disable */
import { bi10GridComponent } from "../../watchdog_includes/base_i10_UI_mixins"

export default {
  props: [
    'P_buttonText',
    'P_buttonWidth',
    'P_buttonHeight',
    'P_buttonColor',
    'P_buttonPadding',
    'P_fontColor',
    'P_fontSize',
    'P_fontWeight',
    'P_imgSrc',
    'P_imgWidth',
    'P_imgHeight',
    'P_flexDirection',
    'P_buttonId',
    'P_makeSingleEvent',
    'P_customCss'
  ],
  mixins: [bi10GridComponent],
  computed: {
    C_buttonStyle () {
      const CI = this
      const additionalStyles = {}
      if (CI.P_buttonHeight) additionalStyles['height'] = CI.P_buttonHeight
      if (CI.P_buttonWidth) additionalStyles['width'] = CI.P_buttonWidth
      if (CI.P_buttonColor) additionalStyles['background'] = CI.P_buttonColor
      if (CI.P_buttonPadding) additionalStyles['padding'] = CI.P_buttonPadding
      if (CI.P_flexDirection) additionalStyles['flex-direction'] = CI.P_flexDirection
      return additionalStyles
    },
    C_imgStyle () {
      const CI = this
      const additionalStyles = {}
      if (CI.P_imgWidth) additionalStyles['width'] = CI.P_imgWidth
      if (CI.P_imgHeight) additionalStyles['height'] = CI.P_imgHeight
      return additionalStyles
    },
    C_textStyle () {
      const CI = this
      const additionalStyles = {}
      if (CI.P_fontColor) additionalStyles['color'] = CI.P_fontColor
      if (CI.P_fontSize) additionalStyles['font-size'] = CI.P_fontSize
      if (CI.P_fontWeight) additionalStyles['font-weight'] = CI.P_fontWeight
      return additionalStyles
    }
  },
}
</script>
<style lang="less" scoped>
button {
  background: #AFAFAF;
  border: 1px solid black;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  flex-direction: column;
  cursor: pointer;
  &:active {
    background: #93bac7 !important;
  }
  &.active {
    background: #93bac7 !important;
  }
  div {
    &.img-container {
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    &.text-container {
      color: black;
      font-size: .8rem;
      margin: 0;
      align-self: center;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Grid/GButtonWithImage.vue